import type { VariantLoadingSizeProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { getSizeClass, SR_LOADING_TEXT } from '../helper';
import '../index.less';

function PulseLoading({ className, size = 'md' }: VariantLoadingSizeProps, ref: React.Ref<HTMLDivElement>) {
  return (
    <div ref={ref} className={cn('wg-variant-loading__pulse-loader', getSizeClass(size), className)}>
      <div className="wg-variant-loading__pulse-ring" />
      <span className="wg-variant-loading__sr-only">{SR_LOADING_TEXT}</span>
    </div>
  );
}

const PulseLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingSizeProps>(PulseLoading);
PulseLoadingComponent.displayName = 'PulseLoading';

export default PulseLoadingComponent;
